import { useState } from "react"
import { useTranslation } from "react-i18next"

interface TimerExtensionPopupProps {
  onExtend: () => void
  onClose: () => void
}

const TimerExtensionPopup = ({
  onExtend,
  onClose,
}: TimerExtensionPopupProps) => {
  const { t } = useTranslation()
  const [isVisible, setIsVisible] = useState(true)

  const handleExtend = () => {
    onExtend()
    setIsVisible(false)
  }

  const handleClose = () => {
    onClose()
    setIsVisible(false)
  }

  if (!isVisible) return null

  return (
    <div className="fixed md:bottom-4 md:right-4 md:top-auto md:left-auto top-1/2 left-1/2 transform -translate-y-1/2 -translate-x-1/2 md:translate-y-0 md:translate-x-0 border border-theme_text_light rounded-lg shadow-lg p-4 max-w-sm text-black bg-white z-50">
      <h3 className="text-lg font-semibold mb-2">
        {t("timer.time_running_out", "Time is running out!")}
      </h3>
      <p className="mb-4">
        {t("timer.extend_session_question", "Would you like to extend your session by 15 minutes?")}
      </p>
      <div className="flex justify-end space-x-2">
        <button
          onClick={handleClose}
          className="px-4 py-2 text-black hover:text-theme_text_medium_plus"
        >
          {t("timer.no_thanks", "No thanks")}
        </button>
        <button
          onClick={handleExtend}
          className="px-4 py-2 bg-theme_accent text-theme_accent_contrast rounded hover:bg-theme_accent_light"
        >
          {t("timer.extend_time", "Extend time")}
        </button>
      </div>
    </div>
  )
}

export { TimerExtensionPopup }
